import { useLocalStorage } from "../../hooks/useLocalStorage.js";
import { useState } from "react";
import { Button, Icon } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import { MdComputer, MdOutlineWeb } from "react-icons/md";
// src/components/BrowserCheck/index.tsx
var { userAgent } = navigator;
var isChrome = false;
var isMobile = false;
if (userAgent.match(/chrome|chromium|crios/i)) isChrome = true;
else if (userAgent.match(/firefox|fxios/i)) isChrome = false;
else if (userAgent.match(/safari/i)) isChrome = false;
else if (userAgent.match(/opr\//i)) isChrome = false;
else if (userAgent.match(/edg/i)) isChrome = false;
if (userAgent.match(/android/i)) isMobile = true;
else if (userAgent.match(/iphone/i)) isMobile = true;
var BROWSER_CHECK_KEYS = {
	chrome: "chrome",
	mobile: "mobile"
};
function BrowserCheck() {
	const [userAckdBrowserChecks, setUserAckdBrowserChecks] = useLocalStorage("browser_check_acks", []);
	const [showBrowserWarnings, setShowBrowserWarnings] = useState(() => {
		const browserWarnings = [];
		if (!isChrome && !userAckdBrowserChecks.includes(BROWSER_CHECK_KEYS.chrome)) browserWarnings.push([BROWSER_CHECK_KEYS.chrome, () => /* @__PURE__ */ jsxs("div", {
			className: "gap-y-lg flex flex-col items-center",
			children: [/* @__PURE__ */ jsx(Icon, {
				Icon: MdOutlineWeb,
				size: "xxl"
			}), /* @__PURE__ */ jsxs("span", {
				className: "text-center text-lg",
				children: [
					/* @__PURE__ */ jsx("strong", { children: "THERMS is best used with Google Chrome browser" }),
					/* @__PURE__ */ jsx("br", {}),
					/* @__PURE__ */ jsx("br", {}),
					" You are using a browser that may not provide the best user experience."
				]
			})]
		})]);
		if (isMobile && !userAckdBrowserChecks.includes(BROWSER_CHECK_KEYS.mobile)) browserWarnings.push([BROWSER_CHECK_KEYS.mobile, () => /* @__PURE__ */ jsxs("div", {
			className: "gap-y-lg flex flex-col items-center",
			children: [/* @__PURE__ */ jsx(Icon, {
				Icon: MdComputer,
				size: "xxl"
			}), /* @__PURE__ */ jsxs("span", {
				className: "text-center text-lg",
				children: [
					"This web-app is designed to be used on a desktop/laptop computer.",
					/* @__PURE__ */ jsx("br", {}),
					/* @__PURE__ */ jsx("br", {}),
					"Download the mobile apps for iOS and Android or use a full-screen device to use all features."
				]
			})]
		})]);
		return browserWarnings;
	});
	if (showBrowserWarnings.length) {
		const key = showBrowserWarnings[0][0];
		const Warning = showBrowserWarnings[0][1];
		return /* @__PURE__ */ jsx("div", {
			className: "p-base fixed left-0 top-0 flex",
			style: {
				background: "rgba(0,0,0,0.85)",
				height: "100vh",
				width: "100vw",
				zIndex: 9999999
			},
			children: /* @__PURE__ */ jsx("div", {
				className: "max-w-(--breakpoint-sm) m-auto",
				children: /* @__PURE__ */ jsxs("div", {
					className: "gap-y-base flex flex-col",
					children: [/* @__PURE__ */ jsx(Warning, {}), /* @__PURE__ */ jsx(Button, {
						onClick: () => {
							setShowBrowserWarnings(showBrowserWarnings.slice(1));
							setUserAckdBrowserChecks((prev) => [...prev, key]);
						},
						size: "lg",
						variant: "main",
						children: "I Understand"
					})]
				})
			})
		});
	}
	return null;
}
export { BrowserCheck };

//# sourceMappingURL=index.js.map